import React from 'react';
import styled from 'styled-components';
import { Table } from '../../ui-kit';
import { IconArrowRightLong } from '../../ui-kit/icons';
import { FormattedPeriod } from '../../../utils/time';
import colors, { fontColors } from '../../../utils/colors';
import round from '../../../utils/round';

const stateTranslation = {
  red: 'below_required',
  yellow: 'on_required',
  green: 'above_buffer'
};

const StyledScheduleWarning = styled.span`
  background: ${props => colors[stateTranslation[props.state]]};
  color: ${props => fontColors[stateTranslation[props.state]] || 'white'};
  border-radius: 5px;
  display: inline-block;
  font-weight: 600;
  margin: 0 2px 0 0;
  padding: 6px;
`;

const DeteriorationCols = ({ deterioration }) => (
  <>
    <td>{deterioration.rule.name}</td>
    <td style={{ textWrap: 'nowrap' }}>
      <StyledScheduleWarning state={deterioration.before.status}>
        {round(deterioration.before.value, 2)}
      </StyledScheduleWarning>{' '}
      <IconArrowRightLong />{' '}
      <StyledScheduleWarning state={deterioration.after.status}>
        {round(deterioration.after.value, 2)}
      </StyledScheduleWarning>
    </td>
    <td>
      {[deterioration.after.description].flat().map((d, index) => (
        <p key={index}>{d}</p>
      ))}
    </td>
  </>
);

const WorkingTimeDirectiveWarningTemplate = ({ warnings }) => {
  return (
    <Table bordered condensed hover>
      <thead>
        <tr>
          <th>{I18n.t('activerecord.models.user')}</th>
          <th>{I18n.t('attributes.period')}</th>
          <th>{I18n.t('attributes.name')}</th>
          <th>{I18n.t('activerecord.attributes.warnings/warning_change.warning_change')}</th>
          <th>{I18n.t('attributes.description')}</th>
        </tr>
      </thead>
      <tbody>
        {warnings.map(warning => (
          <React.Fragment key={warning.start_time}>
            <tr>
              <td rowSpan={warning.deteriorations.length}>
                {warning.user?.first_name} {warning.user?.last_name}
              </td>
              <td rowSpan={warning.deteriorations.length}>
                <FormattedPeriod
                  start={warning.start_time}
                  end={warning.end_time}
                  showNowLabel={false}
                  detailed={true}
                />
              </td>
              <DeteriorationCols deterioration={warning.deteriorations[0]} />
            </tr>
            {warning.deteriorations.slice(1).map((deterioration, index) => (
              <tr key={index}>
                <DeteriorationCols deterioration={deterioration} />
              </tr>
            ))}
          </React.Fragment>
        ))}
      </tbody>
    </Table>
  );
};

export default WorkingTimeDirectiveWarningTemplate;
